const auth = {
  errors: {
    handoff: {
      description: 'This session can no longer be resumed.',
      suggestion: 'Return to Safety Center and open a new chat session.',
      suggestionHeading: 'Next step:',
      title: 'Session link unavailable',
    },
    network: {
      description: 'Unable to connect to the chat server.',
      suggestions: {
        connection: 'Verify that your internet connection is working.',
        retry: 'Try again in a few moments.',
      },
      suggestionHeading: 'What you can try:',
      title: 'Server connection failed',
    },
    server: {
      description: 'The chat server is experiencing issues.',
      suggestions: {
        refresh: 'Try refreshing the page.',
        support: 'Contact support if the problem persists.',
        wait: 'Wait a few moments for the server to recover.',
      },
      suggestionHeading: 'What you can try:',
        title: 'Server error',
    },
  },
  loading: {
    almostReady: 'Almost ready',
    initializing: 'Initializing SpeedGauge Coach AI',
    preparingDashboard: 'Preparing your dashboard',
    securingConnection: 'Securing your connection',
    validatingCredentials: 'Validating credentials',
  },
  actions: {
    returnToSafetyCenter: 'Return to Safety Center',
    retryConnection: 'Try again',
    retryConnectionTitle: 'Try connecting to the server again',
    retryingConnection: 'Retrying...',
    retryingConnectionLabel: 'Retrying connection',
    returnToSafetyCenterTitle: 'Return to Safety Center',
  },
  guard: {
    creatingSession: 'Creating your session...',
    redirectLoopDetected: 'Sign-in could not be completed. Please try again.',
    redirectingToSignIn: 'Redirecting to sign in...',
  },
  lastError: 'Last error: {{time}}',
  loadingSession: 'Loading your session...',
  sessionUnavailable: 'Your session is unavailable. Please sign in again.',
} as const;

export default auth;